var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDent(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    fill: "#666",
    r: 16
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.082 21.15a1.533 1.533 0 01-2.072.545l-4.779-2.71v-1.72l1.518-.86 4.778 2.709c.726.411.974 1.323.555 2.035zm-7.565 3.659c0 .823-.679 1.49-1.517 1.49-.838 0-1.517-.667-1.517-1.49V19.39L16 18.53l1.517.86zM8.99 21.695a1.533 1.533 0 01-2.072-.546 1.476 1.476 0 01.555-2.035l4.778-2.71 1.518.861v1.72zm-1.517-8.809a1.476 1.476 0 01-.555-2.035 1.533 1.533 0 012.072-.546l4.779 2.71v1.72l-1.518.86zm7.01-5.695c0-.823.68-1.49 1.517-1.49.838 0 1.517.667 1.517 1.49v5.418L16 13.47l-1.517-.86zm3.748 8.354l.804.455-.804.455zm-1.517-1.67l.803-.456v.911zm-2.231.455v-.91l.803.455zm-.714 2.125L12.965 16l.804-.455zm1.517 1.67l-.803.456v-.911zm2.231-.455v.91l-.803-.455zM16 17.72l-1.517-.86v-1.72L16 14.28l1.517.86v1.72zm7.01-7.415a1.533 1.533 0 012.072.546c.42.712.17 1.624-.555 2.035l-4.778 2.71-1.518-.861v-1.72zm1.874 8.202L20.463 16l4.421-2.507a2.17 2.17 0 00.817-2.993c-.616-1.048-1.981-1.407-3.048-.802l-4.422 2.507V7.19C18.231 5.981 17.232 5 16 5c-1.232 0-2.231.981-2.231 2.191v5.014L9.347 9.698C8.28 9.093 6.915 9.452 6.3 10.5a2.17 2.17 0 00.817 2.993L11.537 16l-4.42 2.507a2.17 2.17 0 00-.818 2.993c.616 1.048 1.981 1.407 3.048.802l4.422-2.507v5.014c0 1.21.999 2.191 2.231 2.191 1.232 0 2.231-.981 2.231-2.191v-5.014l4.422 2.507c1.067.605 2.432.246 3.048-.802a2.17 2.17 0 00-.817-2.993z",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDent);
export default __webpack_public_path__ + "static/media/dent.b8216efd0370af0d93f9b4cc8efe1610.svg";
export { ForwardRef as ReactComponent };